import {
  React,
  useState,
  useForm,
  useDispatch,
  toast,
} from "../../Components/Imports/import";
import Modal from "react-modal";
import CloseIcon from "../../Assets/Svg/close-icon.svg";
import "./PrReleasePopup.css";
import CustomPopup from "../CustomPopup/CustomPopup";
import areIcon from "../../Assets/Svg/areyousure-icon.svg";
import successIcon from "../../Assets/Svg/success-icon.svg";
import { useTranslation } from "../../../src/Components/Imports/import";
import {
  checkVendorCodes,
  currentPrReleaseDataAction,
} from "../../Store/actions/prReleaseActions";

// PrReleasePopup Component
const PrReleasePopup = ({
  PrReleaseIsOpen,
  PrReleaseCloseModal,
  PrReleaseFormTitle,
  rowData,
  selectedRows,
}) => {
  const dispatch = useDispatch();
  const [showAreYouSurePopup, setShowAreYouSurePopup] = useState(false);
  const [isEditMode, setIsEditMode] = useState();
  const [vendorCodes, setVendorCodes] = useState("");
  const [vendorCodeError, setVendorCodeError] = useState("");
  const { t } = useTranslation();
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm();

  const validateVendorCodes = (input) => {
    if (!input || input.trim() === "") {
      return "";
    }

    if (input.includes(",,")) {
      return "Invalid format: Double commas are not allowed";
    }

    if (/\s,|,\s/.test(input)) {
      return "Invalid format: Spaces around commas are not allowed";
    }

    if (input !== input.trim()) {
      return "Invalid format: Leading or trailing spaces are not allowed";
    }

    const codes = input.split(",").map((code) => code.trim());

    if (codes.some((code) => code === "")) {
      return "Invalid format: Empty vendor codes are not allowed";
    }

    const lowerCaseCodes = codes.map((code) => code.toLowerCase());
    const uniqueCodes = new Set(lowerCaseCodes);
    if (uniqueCodes.size !== codes.length) {
      return "Duplicate vendor codes are not allowed";
    }

    return "";
  };

  const resetFormAndState = () => {
    reset();
    setVendorCodes("");
    setVendorCodeError("");
  };
  const handleVendorCodeChange = (e) => {
    const value = e.target.value;
    setVendorCodes(value);

    const error = validateVendorCodes(value);
    setVendorCodeError(error);

    setValue("VendorCode", value, { shouldValidate: true });
  };

  const handleVendorCodeBlur = () => {
    const error = validateVendorCodes(vendorCodes);
    setVendorCodeError(error);
  };

  const onSubmit = async (data, e) => {
    e.preventDefault();
    try {
      const vendorError = validateVendorCodes(vendorCodes);
      if (vendorError) {
        setVendorCodeError(vendorError);
        return;
      }      
      let formattedData = { ...data };
      let vendorCodesArray = [];

      if (vendorCodes && vendorCodes.trim() !== "") {
        vendorCodesArray = vendorCodes
          .split(",")
          .map((code) => code.trim())
          .filter((code) => code !== "");
      }
      formattedData.vendorCodes = vendorCodesArray;
      delete formattedData.VendorCode;
      if (formattedData.vendorCodes && formattedData.vendorCodes.length > 0) {
        const vendorCheckResponse = await dispatch(
          checkVendorCodes({ vendorCodes: formattedData.vendorCodes })
        );
        if (!vendorCheckResponse || vendorCheckResponse.status !== 200) {
          toast.error(
            vendorCheckResponse?.data?.message ||
              "Error validating vendor codes. Please try again."
          );
          return;
        }
        const notExistingVendorCodes =
          vendorCheckResponse?.data?.data?.notExistingVendorCodes || [];

        if (notExistingVendorCodes.length > 0) {
          toast.error(
            `Invalid vendor codes: ${notExistingVendorCodes.join(
              ", "
            )}. Please check and try again.`
          );
          return;
        }
      }
      if (selectedRows.length > 1) {
        await dispatch(currentPrReleaseDataAction(formattedData));
      } else {
        formattedData.PrCreatedId = [rowData.PrCreatedId];
        formattedData.PR_Company = rowData.PR_Company;
        await dispatch(currentPrReleaseDataAction(formattedData));
      }

      setShowAreYouSurePopup(true);
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "An unexpected error occurred. Please try again."
      );
    }
  };

  const closeAreYouSure = () => {
    setShowAreYouSurePopup(false);
  };

  const onClickCancel = async () => {
    reset();
    setVendorCodes("");
    setVendorCodeError("");
    PrReleaseCloseModal();
  };
  const isSubmitDisabled = () => {
    return vendorCodeError !== "" || Object.keys(errors).length > 0;
  };

  return (
    <>
      <div className="d-flex justify-content-center">
        <Modal
          isOpen={PrReleaseIsOpen}
          onRequestClose={PrReleaseCloseModal}
          className="pr-release-cre-modal"
          overlayClassName="create-modal-overlay"
          shouldCloseOnOverlayClick={false}
        >
          <div className="create-user-title">
            <div className="d-flex">
              <h2 style={{ marginRight: "20px" }}>{PrReleaseFormTitle}</h2>
            </div>
            <img
              src={CloseIcon}
              alt=""
              onClick={() => {
                reset();
                setVendorCodes("");
                setVendorCodeError("");
                PrReleaseCloseModal();
              }}
            />
          </div>
          <form onSubmit={handleSubmit(onSubmit)} className="pr-rele-labels">
            <br />
            <div className="date-main-container">
              <div>
                <label>{t("Bidding End")}</label>
                <br />
                <input
                  className="pr-bid-end-inp"
                  type="date"
                  {...register("BiddingDate", {
                    required: true,
                  })}
                />

                {errors.BiddingDate && (
                  <span className="error-msg">
                    {t("Please select the bidding date")}
                  </span>
                )}
              </div>
              <div>
                <label>{t("Delivery Date")}</label>
                <br />
                <input
                  className="pr-bid-end-inp"
                  type="date"
                  {...register("DeliveryDate", {
                    required: true,
                  })}
                />
                {errors.DeliveryDate && (
                  <span className="error-msg">
                    {t("Please select the delivery date")}
                  </span>
                )}
              </div>
              <div>
                <div className="pr-rel-code-select">
                  <label htmlFor="code">{t("Code")}</label>
                  <div className="pr-rel-select-container">
                    <select
                      className="pr-code-select"
                      id="code"
                      defaultValue=""
                      {...register("Code", {
                        required: true,
                      })}
                    >
                      <option value="" disabled hidden>
                        {t("Select an option")}
                      </option>
                      <option value="ShutDown">{t("ShutDown")}</option>
                      <option value="TurnAround">{t("TurnAround")}</option>
                      <option value="MRO">{t("MRO")}</option>
                      <option value="Service">{t("Service")}</option>
                      <option value="Contract">{t("Contract")}</option>
                      <option value="CAPEX">{t("CAPEX")}</option>
                      <option value="Project">{t("Project")}</option>
                      <option value="N/A">{t("N/A")}</option>
                      <option value="General">{t("General")}</option>
                      <option value="Logistic">{t("Logistic")}</option>
                      <option value="Process treatment">
                        {t("Process treatment")}
                      </option>
                      <option value="Scrap/Surplus">
                        {t("Scrap/Surplus")}
                      </option>
                      <option value="Wastes Disposal">
                        {t("Wastes Disposal")}
                      </option>
                      <option value="Packing">{t("Packing")}</option>
                    </select>
                    {errors.Code && (
                      <span className="error-msg">
                        {t("Please select the code")}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="pr-rel-inp-tit-text">
              <label>{t("PR Title")}</label>
              <input
                className="penalty-title"
                type="text"
                {...register("PrTitle", {
                  required: true,
                })}
              />
              {errors.PrTitle && (
                <span className="error-msg">{t("Please enter the Title")}</span>
              )}
              <br />
              <label>{t("Note")}</label>
              <br />
              <input
                type="text"
                {...register("Note", {
                  required: true,
                })}
              />{" "}
              {errors.Note && (
                <span className="error-msg">{t("Please enter the Note")}</span>
              )}
              <br />
              <label>{t("Vendor Code")}</label>
              <br />
              <div className="vendor-code-container">
                <input
                  type="text"
                  className="vendor-code-input"
                  value={vendorCodes}
                  onChange={handleVendorCodeChange}
                  onBlur={handleVendorCodeBlur}
                  placeholder="e.g., V001,V002,V003"
                />
              </div>
              {vendorCodeError && (
                <span className="error-msg">{t(vendorCodeError)}</span>
              )}
            </div>
            <div className="pt-3 create-btns-div">
              <button
                type="button"
                className="um-create-btn"
                onClick={onClickCancel}
              >
                {t("Cancel")}
              </button>

              <button
                type="submit"
                className="um-submit-btn"
                disabled={isSubmitDisabled()}
              >
                {t("Submit")}
              </button>
            </div>
          </form>
        </Modal>
      </div>

      <CustomPopup
        isOpenPopup={showAreYouSurePopup}
        closePopup={closeAreYouSure}
        image={areIcon}
        title="Are you sure!"
        text={"You want to Release this PR ?"}
        btn1="Cancel"
        btn2="Confirm"
        successTitle="Done!"
        successText={"PR released Successfully"}
        successIcon={successIcon}
        btn3="Ok"
        closeFormPopup={PrReleaseCloseModal}
        reset={resetFormAndState}
        isEditMode={isEditMode}
        setIsEditMode={setIsEditMode}
        scenarioType={
          selectedRows?.length > 1
            ? "releaseMultiplePr"
            : "releasePr" || "releasePr"
        }
        userData={rowData}
        selectedRows={selectedRows}
      />
    </>
  );
};

export default PrReleasePopup;